
















































































































































































































import {Getter, Action, Mutation} from "vuex-class";
import Component from "vue-class-component";
import {
  SelectWings,
  ToggleWings,
  DatePickerWings,
  FastDateGroupWings,
  NumberWings,
} from 'wings-ui-components';
import {PropSync, Watch} from 'vue-property-decorator'
import BaseFilter from "@/components/Filter/BaseFilter";
import {MailNotifyGroupFilterParams} from "@/store/mail_notify/statistic/types";
import {beginningOfCurrentDay,currentDate,dateFilter} from "@/utils/date-util";
import {notifyError, notifyWarning} from "@/utils/notify-helper";
import { MsgTransports } from '@/store/types';
import {getTranslatedParams} from "@/utils/notify-utils";
import {ActionLog} from "@/store/auth/types";

@Component({
  components: {
    NumberWings,
    SelectWings,
    ToggleWings,
    DatePickerWings,
    FastDateGroupWings,
  }, filters: {dateFilter}
})
export default class MNGroupFilter extends BaseFilter<MailNotifyGroupFilterParams> {
  @PropSync('show') is_show!: boolean;
  @PropSync("filterClone") propFilterClone!: any;

  @Mutation('setMailNotifyStaticGroup') setStatistic: any

  @Getter("mailNotifyGroupBy") groupByList: any;
  @Getter("mailNotifyGroupByOptionally") groupByOptionallyList: any;
  @Getter("managementServices") mnServices: any;
  @Getter("managementTemplates") managementTemplatesList: any;
  @Getter("messageTypes") messageTypesList: any;

  @Action("getMailNotifyStatisticGroup") actionMailNotifyStatisticGroup: any;
  @Action("exportMailNotifyStatisticGroup") actionExportMailNotifyStatisticGroup: any;
  @Action("getManagementServices") actionGetMailNotifyServices: any;
  @Action("getManagementTemplates") actionGetManagementTemplates: any;
  @Action("getPartners") actionGetPartners: any;
  @Action("getAccounts") actionGetAccounts: any;
  @Action("getMessageTypes") actionGetMessageTypes: any;
  @Action("getServiceProviders") actionGetServiceProviders: any;
  @Action("actionLog") actionLog: any;

  defaultFilter(): MailNotifyGroupFilterParams {
    return new MailNotifyGroupFilterParams(beginningOfCurrentDay(), currentDate(), "day")
  }

  mnTemplatesList = []
  mnRoutesList = ['vk', 'ok']

  params: object = {transport: MsgTransports.MAILNOTIFY};
  partnersList: any = []
  accountsList: any = []
  serviceProvidersList:  any = []

  group_by = null;
  group_by_optionally = null;

  filterKeys: object = {
    "mn_service_name": "mn_service",
    "mn_tmpl": "mn_template",
    "routes" : "channel",
    "broker_account_login" : "account"
  }

  async getPartnersList(filter: any) {
    const items = await this.actionGetPartners({...this.params, ...filter});
    this.partnersList = (filter?.page_number > 1) ? this.partnersList.concat(items) : items
  }

  async getAccountsList(filter: any) {
    const items = await this.actionGetAccounts({...this.params, ...filter});
    this.accountsList = (filter?.page_number > 1) ? this.accountsList.concat(items) : items
  }

  async getServiceProvidersList(filter: any) {
    const items = await this.actionGetServiceProviders({...this.params, ...filter});
    this.serviceProvidersList = (filter?.page_number > 1) ? this.serviceProvidersList.concat(items) : items
  }

  async created() {
    this.setStatistic(null)
    this.parseGroupBy()
    try {
      this.actionGetMailNotifyServices();
      this.actionGetManagementTemplates()
      this.actionGetMessageTypes();
    } catch (err) {
      notifyError(err);
    }
    if (this.filter.partner) this.partnersList = await this.actionGetPartners({name: this.filter.partner});
    if (this.filter.broker_account_login) this.accountsList = await this.actionGetAccounts({login: this.filter.broker_account_login});
    if (this.filter.service_provider) this.serviceProvidersList = await this.actionGetServiceProviders({name: this.filter.service_provider});
  }

  async onFilteredAction() {
    this.setStatistic(null);
    this.mergeGroupBy();
    try {
      this.logObject = {
        action_page: this.$route.meta.msgKey,
        action: "Viewing",
        action_status: "success",
        object_type: "Group statistics",
        addititional_info: getTranslatedParams(this.filter, this.filterKeys)
      };
      const resp = await this.actionMailNotifyStatisticGroup(this.filter);
      await this.actionLog(this.logObject);
      if (resp.status == 204) {
        notifyWarning()
      }
    } catch (err) {
      await this.actionLog({...this.logObject, action_status: "failed"});
      notifyError(err);
    }
  }

  // Override
  async doActionExport(): Promise<any> {
    this.mergeGroupBy();
    return await this.actionExportMailNotifyStatisticGroup(this.filter);
  }

  mergeGroupBy() {
    this.filter.group_by = [this.group_by, this.group_by_optionally].filter(item => item).join(',');
    this.$set(this.sendFilter, 'group_by', this.filter.group_by);
    this.$emit('onGroupByChange', {groupBy: this.group_by, optionallyGroupBy: this.group_by_optionally});
  }

  parseGroupBy() {
    if (this.filter.group_by.length == 0) return

    this.filter.group_by.split(',').forEach((item:any) => {
      if (this.groupByList.includes(item)) this.group_by = item;
      else this.group_by_optionally = item;
    })
  }

  @Watch('filter.mn_service_name')
  onMNServiceChange(val: string) {
    this.filter.mn_tmpl = ''
    this.mnTemplatesList = val ? this.managementTemplatesList.filter((template: any) => template.mn_service_name == val) : []
  }

  @Watch("filter", { immediate: true, deep: true })
  onFilterChanged(newVal: MailNotifyGroupFilterParams) {
    this.propFilterClone = newVal;
  }
}
